module.exports = __webpack_public_path__ + "static/media/message-circle.e348f2f6.svg";